import React, { useEffect, useState } from "react";
import 'rc-slider/assets/index.css';
import './MeFeedBackFormStyle.css'
import Button from '../../../components/Button/Button'
// import InputField from '../../../components/InputField/InputField'
import RangeSlider from '../../../components/RangeSlider/RangeSlider'
import { useDispatch, useSelector } from "react-redux";
import { clearState, menteeData, saveUserFeedbackAnswers } from "../../../reducer/menteeSlice";
import { useNavigate, useParams } from "react-router";
import PageLoader from "../../../components/loaders/PageLoader/PageLoader";
import SuccessToast from "../../../components/Toast/SuccessToast";
import ErrorToast from "../../../components/Toast/ErrorToast";
import InputField from "../../../components/InputField/InputField";

const MenteeFeedback = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { feedbackId } = useParams();

    const [index, setIndex] = useState(1);
    const [feedback, setFeedback] = useState({
        answer1: "",
        answer2: "",
        answer3: "",
        answer4: 0,
    });

    //Toast states
  const [isShowSuccess, setIsShowSuccess] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [isShowError, setIsShowError] = useState(false);
  const [errMessage, setErrMessage] = useState("");

    const { isFetching, isSuccess, isError, errorMessage } = useSelector(menteeData);

    const validation = () => {
        if(index === 1 && !feedback["answer1"]) return true;
        if(index === 2 && !feedback["answer2"]) return true;
        if(index === 3 && !feedback["answer3"]) return true;
        return false;
    }

    const handleIndexChange = (type) => {
        if(type === "next") {
            if(!validation()) { 
                if(index === 4) {
                    dispatch(saveUserFeedbackAnswers({feedbackId, obj: feedback}))
                    return;
                }
                setIndex(prev => prev + 1);
            }
            else {
                setIsShowError(true);
                setErrMessage("Feedback is mandatory!");
            }
        }
        else {
            if(index === 1) return;
            setIndex(prev => prev - 1);
            
        }
    };

    const handleSliderChange = (value,index) => {
        setFeedback(prev => ({
            ...prev,
            [`answer${index}`]: value
        }));
    };
    
    const handleRadioChange = (e, index) => {
        const { value } = e.target;
        setFeedback(prev => ({
            ...prev,
            [`answer${index}`]: value
        }));
    }

    useEffect(() => {
        if(isSuccess) {
            setIsShowSuccess(true);
            setSuccessMessage("Success");
            setTimeout(() => {
                navigate("/mentee")
            },1000)
            dispatch(clearState());
        }
    },[isSuccess]);

    useEffect(() => {
        if(isError) {
            setIsShowError(true);
            setErrMessage(errorMessage);
            dispatch(clearState());
        }
    },[isError])

    return (
        <>
        {isFetching && <PageLoader />}
        <ErrorToast
        show={isShowError}
        setShow={() => setIsShowError(false)}
        message={errMessage}
      />
        <SuccessToast
        show={isShowSuccess}
        setShow={() => setIsShowSuccess(false)}
        message={successMessage}
      />

     
        <div className="MentorsFbackWrapper ">
        <div className="logogetpreepedimg" onClick={() => navigate('/mentee')}>
            <img src="/assets/svg/getPreppedLogo.svg" alt="" />
        </div>
            <div className="MnFeedBackwrapper">
                <div className={`bodyDataForallUserdata MteeFbackFormTab ${index === 1 && 'active'}`}>
                    <div className="MnfBackArea">
                        <h3 className='Mnque-1'>Was the call <span>helpful</span> for you ?
                        </h3>
                        <div className="flex RadioFbackform">
                            <InputField onChange={(e) => handleRadioChange(e,1)} value={"Yes"} checked={feedback["answer1"] === "Yes"} type={"radio"} labelName={"Yes"} id={"yes"} />
                            <InputField onChange={(e) => handleRadioChange(e,1)} value={"No"} checked={feedback["answer1"] === "No"} type={"radio"} labelName={"No"} id={"no"} />
                            <InputField onChange={(e) => handleRadioChange(e,1)} value={"A little bit"} checked={feedback["answer1"] === "A little bit"} type={"radio"} labelName={"A little bit"} id={"maybe"} />
                        </div>
                    </div>

                </div>
                {/* second */}
                <div className={`bodyDataForallUserdata MteeFbackFormTab ${index === 2 && 'active'}`}>
                    <div className="MnfBackArea">
                        <h3 className='Mnque-1'>Would you like to schedule a <span> call again</span>  with the <span>same </span>
                            Mentor?
                        </h3>
                        <div className="flex RadioFbackform">
                            <InputField onChange={(e) => handleRadioChange(e,2)} value={"Yes"} checked={feedback["answer2"] === "Yes"} type={"radio"} labelName={"Yes"} id={"yes1"} />
                            <InputField onChange={(e) => handleRadioChange(e,2)} value={"No"} checked={feedback["answer2"] === "No"} type={"radio"} labelName={"No"} id={"no1"} />
                            <InputField onChange={(e) => handleRadioChange(e,2)} value={"Unsure"} checked={feedback["answer2"] === "Unsure"} type={"radio"} labelName={"Unsure"} id={"Unsure"} />
                        </div>
                    </div>
                </div>
                {/* third */}
                <div className={`bodyDataForallUserdata MteeFbackFormTab ${index === 3 && 'active'}`}>
                    <div className="MnfBackArea">
                        <h3 className='Mnque-1'>Was the Mentor <span> able to answer</span> your questions?
                        </h3>
                        <div className="flex RadioFbackform">
                            <InputField onChange={(e) => handleRadioChange(e,3)} value={"Yes"} checked={feedback["answer3"] === "Yes"} type={"radio"} labelName={"Yes"} id={"yes2"} />
                            <InputField onChange={(e) => handleRadioChange(e,3)} value={"No"} checked={feedback["answer3"] === "No"} type={"radio"} labelName={"No"} id={"no2"} />
                            <InputField onChange={(e) => handleRadioChange(e,3)} value={"A few"} checked={feedback["answer3"] === "A few"} type={"radio"} labelName={"A few"} id={"Afew"} />
                            <InputField onChange={(e) => handleRadioChange(e,3)} value={"Most of them"} checked={feedback["answer3"] === "Most of them"} type={"radio"} labelName={"Most of them"} id={"most"} />
                        </div>
                    </div>
                </div>
                {/* fourth */}
                <div className={`bodyDataForallUserdata MteeFbackFormTab ${index === 4 && 'active'}`}>
                    <div className="MnfBackArea">
                        <h3 className='Mnque-1'>Rate your <span>experience</span> with the <span>Mentor</span> ? </h3>
                        <div className="RangeSliderWrapper">
                            <RangeSlider onChange={(e) => handleSliderChange(e,4)} />
                        </div>
                    </div>
                </div>

                <div className="border-btm w-100"></div>

                <div className="Headingforallheader">
                    <div className="pagesdotesWrappper">
                        <span className={`pagesdotescircle ${index === 1 && 'active'}`}></span>
                        <span className={`pagesdotescircle ${index === 2 && 'active'}`}></span>
                        <span className={`pagesdotescircle ${index === 3 && 'active'}`}></span>
                        <span className={`pagesdotescircle ${index === 4 && 'active'}`}></span>
                    </div>
                    <div className="buttonfbackfrom">
                    {index === 1 ? <div></div> : <Button name={'Back'} className={'flex gap-5'} src={'/assets/img/arrow-circle-right.png'} onClick={() => handleIndexChange("back")}  /> }
                    {<Button name={index === 4 ? 'Submit' : 'Next'} className={'BlackFillButton'} onClick={() => handleIndexChange("next")} />}
                    </div>
                </div>
            </div>

        </div>
        </>
    )
}

export default MenteeFeedback